import React, { useContext, useEffect, useState } from "react";
import useLabels from "../../../../../../../customHooks/useLabels";
import Download from "../../../../../../../images/DownloadImage.svg";
import { Button } from "../../../../../../../stories/Button/Button";
import { Title } from "../../../../../../../stories/Title/Title";
import Close from "../../../../../../../images/Close.svg";

import {
  getAging,
  ticketPriorityClassName,
  ticketStatusClassName,
  toInputStandardDate,
} from "../../../../../../../utils/UtilFunctions";
import {
  AtsTicketsByNodeData,
  TicketDetailsByNode,
} from "../../../../masters/items/queries/queries";
import { useLazyQuery } from "@apollo/client";
import { nodeVar } from "../../../../../../../utils/commonQueryTypes";

import { MapsContext } from "../../../context/context";
import { IObjectKeys } from "../../../../../../../utils/formTypes";
import { getDownloadUrl } from "../../../../../../../utils/DownloadFile";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import useServerDateandTime from "../../../../../../../customHooks/useServerDateandTime";
import { TicketStatus } from "../../../../../../../utils/constants";
import { AssetViewDrawer } from "../../../../../../../styles/CustomDrawerStyles";
import { CustomTooltip } from "../../../../../../../styles/TooltipStyles";
import Information from "../../../../../../../images/Info.svg";
import { TOOLTIP_COLORS } from "../../../../../../../styles/Variables";
import { empType } from "../../../../../../../utils/Enum.types";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
interface TicketDetailsInterface extends IObjectKeys {
  ticketNo: string;
  reportedDateAndTime: string;
  ticketReason: string;
  priority: string;
  assigned_to: string;
  ticket_raised_by_name: string;
  ticket_raised_by_desgn: string;
  ticket_raised_by_phone_no: string;
  ticket_raised_by_kgid: number;
  ticket_raised_by_metalNo: number;
  ticket_raised_by_address: string;
  ticket_raised_by_place: string;
  ticket_raised_by_state: string;
  ticket_raised_by_pin: string;
  ticket_raised_by_email: string;
  assetStatus: string;
  openRemarks: string;
  attachments: string;
  ticketStatus: string;
  item_icon: string;
  item_desc: string;
  prodSerialNo: string;
  maintainedBy: string;
}
const DetailedView = ({ setModalFlag }: Props) => {
  const { serverDate } = useServerDateandTime();

  const { state } = useContext(MapsContext);

  const { customer_id } = useUrlParams();

  const [GetTicket, { data, loading, error }] = useLazyQuery<
    AtsTicketsByNodeData,
    nodeVar
  >(TicketDetailsByNode);
  const [ticketDetailsModal, setTicketDetailsModal] = useState(false);

  const [ticketDetails, setTicketDetails] = useState<TicketDetailsInterface>({
    ticketNo: "",
    reportedDateAndTime: "",
    ticketReason: "",
    priority: "",
    assigned_to: "",
    ticket_raised_by_name: "",
    ticket_raised_by_desgn: "",
    ticket_raised_by_phone_no: "",
    ticket_raised_by_kgid: 0,
    ticket_raised_by_metalNo: 0,
    ticket_raised_by_address: "",
    ticket_raised_by_place: "",
    ticket_raised_by_state: "",
    ticket_raised_by_pin: "",
    ticket_raised_by_email: "",
    assetStatus: "",
    openRemarks: "",
    attachments: "",
    ticketStatus: "",
    item_desc: "",
    item_icon: "",
    prodSerialNo: "",
    maintainedBy: "",
  });

  // const getAging = ( date: string ) =>
  // {
  //   if ( serverData && !serverLoading )
  //   {
  //     const presentDate = new Date( serverDate );
  //     const ticketDate = new Date( date );

  //     const diffMs = Math.abs( ticketDate.getTime() - presentDate.getTime() ); // Absolute difference in ms

  //     const diffSec = Math.floor( diffMs / 1000 ); // Total seconds
  //     const diffMin = Math.floor( diffSec / 60 ); // Total minutes
  //     const diffHours = Math.floor( diffMin / 60 ); // Total hours
  //     const diffDays = Math.floor( diffHours / 24 ); // Total days

  //     const remainingHours = diffHours % 24; // Hours excluding full days
  //     const remainingMinutes = diffMin % 60; // Minutes excluding full hours
  //     const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

  //     let result = "";
  //     if ( diffDays ) result += `${ diffDays } days `;
  //     if ( remainingHours ) result += `${ remainingHours } hrs `;
  //     if ( remainingMinutes ) result += `${ remainingMinutes } mins `;
  //     if ( remainingSeconds ) result += `${ remainingSeconds } secs`;

  //     return result.trim(); // Remove extra spaces
  //   }
  //   return "";
  // };

  useEffect(() => {
    if (state.ticketId) {
      GetTicket({
        variables: {
          id: state.ticketId,
        },
      }).then(async ({ data }) => {
        if (data && data.node) {
          let fileName = "";
          let res = "";
          if (
            data.node.orderedDetails.length &&
            data.node.orderedDetails[0].imagesPath
          ) {
            fileName = `${customer_id}/ticketDetails/${
              data.node.orderedDetails[0].id
            }.${data.node.orderedDetails[0].imagesPath.split(".").pop()}`;
            try {
              res = await getDownloadUrl(fileName, false);
            } catch (err) {
              console.error(err);
            }
          }

          setTicketDetails({
            assetStatus: data.node.status,
            ticketStatus: data.node.status,
            ticketNo: data.node.ticketNo,
            ticketReason: data.node.reason,
            priority: data.node.priority,
            openRemarks: data.node.openRemarks,
            attachments: res,
            assigned_to: data.node.assignedUser.name,
            ticket_raised_by_name: data.node.loggedUser.name,
            ticket_raised_by_desgn: data.node.loggedUser.empType,
            ticket_raised_by_phone_no: data.node.loggedUser.mobile,
            ticket_raised_by_kgid: data.node.loggedUser.kgid,
            ticket_raised_by_metalNo: data.node.loggedUser.metalNo,
            ticket_raised_by_address: data.node.loggedUser.address,
            ticket_raised_by_place: data.node.loggedUser.place,
            ticket_raised_by_state: data.node.loggedUser.state,
            ticket_raised_by_pin: data.node.loggedUser.pin,
            ticket_raised_by_email: data.node.loggedUser.email,
            reportedDateAndTime: data.node.ticketDate,
            item_desc: data.node.item.desc,
            item_icon: data.node.item.icon,
            prodSerialNo: data.node.itemDetails.prodSerialNo,
            maintainedBy: data.node.vendorDetails.desc,
          });
        }
      });
    }
  }, [state.ticketId, GetTicket]);

  if (loading) {
    return <b>Loading....</b>;
  }
  if (data) {
    return (
      <>
        <div className="junc-ticket-details">
          <div className="junc-ticket-details__title">
            <Title>View Ticket Details</Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
          <div className="junc-ticket-details__block">
            <div className="junc-ticket-details__block--header">
              <div className="junc-ticket-details__block--header--flex">
                {ticketDetails.item_icon && (
                  <img
                    src={require(`../../../../../../../images/ItemIcons/${ticketDetails.item_icon}.svg`)}
                    alt=""
                  />
                )}

                <b className="font-blue">{ticketDetails.item_desc}</b>
                {ticketDetails.prodSerialNo ? (
                  <span className="font-grey">
                    ({ticketDetails.prodSerialNo})
                  </span>
                ) : (
                  ""
                )}
              </div>
              {/* <img src={Information} alt="" /> */}
            </div>

            <ul>
              <li>
                <span>Ticket No.</span>
                <span>:</span>
                <div>
                  <b className="font-red">{ticketDetails.ticketNo}</b>
                </div>
              </li>
              <li>
                <span>Reported Date and Time</span>
                <span>:</span>
                <div>
                  <b>
                    {toInputStandardDate(ticketDetails.reportedDateAndTime)}
                  </b>
                </div>
              </li>
              <li>
                <span>Ticket Reason</span>
                <span>:</span>
                <div>
                  <b>{ticketDetails.ticketReason}</b>
                </div>
              </li>
              <li>
                <span>Ageing</span>
                <span>:</span>
                <div>
                  <b>
                    {getAging(ticketDetails.reportedDateAndTime, serverDate)}
                  </b>
                </div>
              </li>
              <li>
                <span>Maintained By</span>
                <span>:</span>
                <div>
                  <b>{ticketDetails.maintainedBy}</b>
                </div>
              </li>
              <li>
                <span>Priority</span>
                <span>:</span>
                <b className={ticketPriorityClassName(ticketDetails.priority)}>
                  {ticketDetails.priority}
                </b>
              </li>
              <li>
                <span>Assigned to</span>
                <span>:</span>

                <div className="junc-ticket-details__block--flex">
                  <b>{ticketDetails.assigned_to}</b>
                  {/* <img src={Information} alt="" /> */}
                </div>
              </li>
              <li>
                <span>Ticket Raised By</span>
                <span>:</span>

                <div className="junc-ticket-details__block--flex">
                  <b>{ticketDetails.ticket_raised_by_name}</b>
                  {/* <img src={Information} alt="" /> */}
                  <CustomTooltip
                    title="View Ticket Details"
                    arrow
                    placement="top"
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: TOOLTIP_COLORS.GREY,
                          "& .MuiTooltip-arrow": {
                            color: TOOLTIP_COLORS.GREY,
                          },
                        },
                      },
                    }}
                  >
                    <img
                      src={Information}
                      alt=""
                      onClick={() => {
                        setTicketDetailsModal(!ticketDetailsModal);
                      }}
                    />
                  </CustomTooltip>
                </div>
              </li>
              <li>
                <span>Ticket Status</span>
                <span>:</span>
                <b className={ticketStatusClassName(ticketDetails.assetStatus)}>
                  {ticketDetails.assetStatus}
                </b>
              </li>
              <li>
                <span>Remarks</span>
                <span>:</span>
                <div>
                  <b>{ticketDetails.openRemarks}</b>
                </div>
              </li>
              <li>
                <span>Attachments</span>
                <span>:</span>

                {ticketDetails.attachments ? (
                  <div className="junc-ticket-details__block--flex">
                    <b>{ticketDetails.attachments}</b>
                    <img src={Download} alt="" />
                  </div>
                ) : (
                  ""
                )}
              </li>
            </ul>
          </div>
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        </div>

        <AssetViewDrawer
          anchor="right"
          open={ticketDetailsModal}
          onClose={() => setTicketDetailsModal(!ticketDetailsModal)}
        >
          <div className="junc-ticket-details">
            <div className="junc-ticket-details__title">
              <Title>Ticket Raised By Details</Title>
              <img
                src={Close}
                alt=""
                onClick={() => setTicketDetailsModal(false)}
              />
            </div>
            <div className="junc-ticket-details__block">
              <ul>
                <li>
                  <span>Name.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_name}</b>
                  </div>
                </li>
                <li>
                  <span>Mobile.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_phone_no}</b>
                  </div>
                </li>
                <li>
                  <span>Email.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_email}</b>
                  </div>
                </li>
                <li>
                  <span>Address.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_address}</b>
                  </div>
                </li>
                <li>
                  <span>Place.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_place}</b>
                  </div>
                </li>
                <li>
                  <span>State.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_state}</b>
                  </div>
                </li>
                <li>
                  <span>KGID.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_kgid}</b>
                  </div>
                </li>
                <li>
                  <span>Metal No.</span>
                  <span>:</span>
                  <div>
                    <b>{ticketDetails.ticket_raised_by_metalNo}</b>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </AssetViewDrawer>
      </>
    );
  } else {
    return <b className="nodata">No data found</b>;
  }
};

export default DetailedView;
